<template>
  <div class="contract-change-audit-orders-container">
    <template v-if="contractChangeAuditOrdersInfo.audit === '1'">
      <!-- (1) PageHeader -->
      <ds-page-header :title="$t('contractChangeAuditOrders.title')" :subtitle="$t('contractChangeAuditOrders.page.subtitle')" />

      <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
      <div class="ds-panel">
        <ds-toolbar :total="page.total" :density="density" :show-column-setting="false" :show-refresh="true"
          @update:density="density = $event" @refresh="_listAuditOrders(page.current, page.size)">
          <template #left>
            <span class="ds-panel__title">{{ $t('contractChangeAuditOrders.title') }}</span>
          </template>
        </ds-toolbar>

        <ds-data-table :data="contractChangeAuditOrdersInfo.contractChangeAuditOrders" :loading="loading"
          :error="hasError" :error-message="errorMessage" :density="density" border
          :empty-description="$t('contractChangeAuditOrders.page.empty')"
          @retry="_listAuditOrders(page.current, page.size)">
          <el-table-column prop="contractCode" :label="$t('contractChangeAuditOrders.contractCode')" align="center" width="150">
            <template slot-scope="scope">
              <span class="ds-num">{{ scope.row.contractCode || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contractName" :label="$t('contractChangeAuditOrders.contractName')" align="left" min-width="160" show-overflow-tooltip />
          <el-table-column prop="contractTypeName" :label="$t('contractChangeAuditOrders.contractType')" align="center" width="130" />
          <el-table-column prop="stateName" :label="$t('contractChangeAuditOrders.contractStatus')" align="center" width="120">
            <template slot-scope="scope">
              <ds-status-tag :label="scope.row.stateName" :text="scope.row.stateName" type="info" />
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('contractChangeAuditOrders.createTime')" align="center" width="160">
            <template slot-scope="scope">
              <span class="ds-num">{{ scope.row.createTime || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractChangeAuditOrders.operation')" align="center" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="_viewChangeDetail(scope.row)">
                {{ $t('contractChangeAuditOrders.view') }}
              </el-button>
              <el-button v-if="scope.row.hasAudit && !scope.row.hasEnd" size="mini" type="text"
                @click="_openAuditOrderModel(scope.row)">
                {{ $t('contractChangeAuditOrders.audit') }}
              </el-button>
              <el-button v-if="scope.row.hasEnd" size="mini" type="text" class="ds-btn-warning" @click="_finishAuditOrder(scope.row)">
                {{ $t('contractChangeAuditOrders.finish') }}
              </el-button>
            </template>
          </el-table-column>
        </ds-data-table>

        <ds-pagination-bar :total="page.total" :page="page.current" :size="page.size"
          :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </template>
    <flow-audit v-else ref="flowAudit" :call-back-listener="'contractChangeAuditOrders'"
      :call-back-function="'notifyAudit'" />
  </div>
</template>

<script>
import { queryContractChangeTask, needAuditContractPlan } from '@/api/resource/contractChangeAuditOrdersApi'
import FlowAudit from '@/components/contract/flowAudit'
import { getUserId } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'ContractChangeAuditOrdersList',
  components: {
    FlowAudit,
    DsPageHeader,
    DsToolbar,
    DsDataTable,
    DsPaginationBar,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      contractChangeAuditOrdersInfo: {
        contractChangeAuditOrders: [],
        total: 0,
        records: 1,
        moreCondition: false,
        userName: '',
        currentUserId: '',
        conditions: {
          planId: '',
          userName: '',
          auditLink: ''
        },
        orderInfo: '',
        procure: false,
        audit: '1'
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.contractChangeAuditOrdersInfo.currentUserId = getUserId()
    this._listAuditOrders(this.page.current, this.page.size)
  },
  methods: {
    async _listAuditOrders(page, rows) {
      try {
        this.loading = true
        this.hasError = false
        this.errorMessage = ''
        this.contractChangeAuditOrdersInfo.audit = '1'
        this.contractChangeAuditOrdersInfo.conditions.page = page
        this.contractChangeAuditOrdersInfo.conditions.row = rows

        const { data, total } = await queryContractChangeTask(this.contractChangeAuditOrdersInfo.conditions)
        this.contractChangeAuditOrdersInfo.contractChangeAuditOrders = Array.isArray(data) ? data : []
        this.contractChangeAuditOrdersInfo.total = total || 0
        this.page.total = total || 0
      } catch (error) {
        console.error('请求失败:', error)
        this.hasError = true
        this.errorMessage = error.message || this.$t('contractChangeAuditOrders.page.loadFailed')
      } finally {
        this.loading = false
      }
    },
    _openAuditOrderModel(auditOrder) {
      this.contractChangeAuditOrdersInfo.orderInfo = auditOrder
      this.contractChangeAuditOrdersInfo.audit = '2'
      auditOrder.startUserId = auditOrder.changePerson
      this.$refs.flowAudit.open(auditOrder)
    },
    async _auditOrderInfo(auditInfo) {
      auditInfo.taskId = this.contractChangeAuditOrdersInfo.orderInfo.taskId
      auditInfo.planId = this.contractChangeAuditOrdersInfo.orderInfo.planId
      auditInfo.contractId = this.contractChangeAuditOrdersInfo.orderInfo.contractId

      try {
        await needAuditContractPlan(auditInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this._listAuditOrders(this.page.current, this.page.size)
      } catch (error) {
        this.$message.error(this.$t('common.handleFailed') + error.message)
      }
    },
    async _finishAuditOrder(auditOrder) {
      const auditInfo = {
        taskId: auditOrder.taskId,
        planId: auditOrder.planId,
        state: '1200',
        remark: this.$t('contractChangeAuditOrders.processEnd'),
        contractId: auditOrder.contractId
      }

      try {
        await needAuditContractPlan(auditInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this._listAuditOrders(this.page.current, this.page.size)
      } catch (error) {
        this.$message.error(this.$t('common.handleFailed') + error.message)
      }
    },
    _viewChangeDetail(plan) {
      this.$router.push({
        path: '/views/contract/contractChangeDetails',
        query: { planId: plan.planId }
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._listAuditOrders(this.page.current, val)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listAuditOrders(val, this.page.size)
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-change-audit-orders-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-btn-warning {
  color: var(--ds-warning, #e6a23c) !important;
}
</style>
